// extracted by mini-css-extract-plugin
export default {"drawer":"publish-snapshot-drawer__drawer","basicForm":"publish-snapshot-drawer__basicForm","actions":"publish-snapshot-drawer__actions"};